import { Component } from '@angular/core';
import { pessoaJuridica } from '../../../pessoa-tipo';

@Component({
    selector: 'sgt-pessoa-tipo-badge-juridica',
    templateUrl: './pessoa-tipo-badge-juridica.component.html',
    styleUrls: ['./pessoa-tipo-badge-juridica.component.less']
})
export class PessoaTipoBadgeJuridicaComponent {
    tipo = pessoaJuridica;
}
